<template>
	<div class="card">
		<div class="card-header mt-2 mb-0 pb-0">
			<div class="d-flex flex-md-row flex-column align-items-md-center align-items-start">
				<div class="d-flex align-items-center">
					<h5 class="header-title my-auto mr-2">{{ __('Cases') }}</h5>
					<div class="d-flex align-items-center">
						<span v-if="pagination && !loading" class="badge brand-primary-badge mr-1">{{ pagination.total }}</span>
						<a v-if="pagination && pagination.total && !isGuestUser()" href="#" @click.prevent="toggleExportDialog"
							class="blue-link">
							<i class="fas fa-file"></i>
							{{ __('EXPORT') }}
						</a>
					</div>
				</div>
	
				<div class="ml-md-auto ml-0 pr-4 mt-3 mt-md-0">
					<tab-navigation v-if="!isGuestUser()"title="Cases" tab-id="case-create" tab-icon="fa-plus"
						:action-label="__('CREATE NEW CASE')" />
				</div>
			</div>
		</div>

		<div class="card-body pt-0">
			<hr />
			<!-- Case Filters -->
			<CaseFilters @filters-updated="applyFilters"></CaseFilters>

			<div v-if="loading" class="text-center my-3">
				<div class="d-flex flex-column align-items-center">
					<div class="spinner-border text-primary mb-3" role="status"></div>
					<span class="text-muted">{{ __('Fetching all cases...') }}</span>
				</div>
			</div>

			<div v-if="!loading && cases != null && cases.length === 0" class="text-center my-3">
				{{ __('No cases have been created yet') }}
			</div>

			<div v-if="cases != null && !loading && cases.length > 0" class="container">
				<div v-for="caseItem in cases" :key="caseItem.id">
					<CaseCard :caseItem="caseItem" :currentRole="currentRole" @pin-case="pinCase"
						@navigate-tab="navigateToTab" @archive-case="archiveCase" />
				</div>

				<pagination :last_page="pagination.last_page" :current_page="pagination.current_page"
					:num_items="cases.length" :num_total="pagination.total">
				</pagination>

				<ExportCases :showExportDialog="showExportDialog" :filters="filters">
				</ExportCases>
			</div>
		</div>
	</div>
</template>

<script>
import CaseFilters from './CaseFilters.vue';
import CasesService from '@/services/cases-service'; // Adjust the path to your service
import TabNavigation from '../generic/TabNavigation.vue';
import ExportCases from './ExportCases.vue';
import CaseCard from './CaseCard.vue';

export default {
	components: {
		CaseFilters,
		TabNavigation,
		ExportCases,
		CaseCard,
	},

	data() {
		return {
			showExportDialog: false,
			cases: null,
			loading: false,
			filters: {},
			pagination: {
				current_page: 1,
				last_page: 1,
				per_page: 10,
				total: 0,
			},
		};
	},

	computed: {
		currentRole() {
			return Spark.state.currentTeam?.users?.find((user) => user.id === Spark.state.user?.id)?.pivot?.role ?? 'member';
		},
	},

	mounted() {
		this.$eventHub.$on('activateTab', this.handleTabActivation);

		this.$on('change-page', (page) => {
			this.getCases(page);
		});
	},

	beforeDestroy() {
		this.$eventHub.$off('activateTab', this.handleTabActivation);
		this.$off('change-page');
	},

	methods: {
		isGuestUser() {
			return !Spark?.userId;
		},

		toggleExportDialog() {
			this.showExportDialog = !this.showExportDialog;
		},

		async handleTabActivation(tabId) {
			if (tabId === 'cases-view') {
				await this.getCases();

				//Check for case id as query param
				const caseId = new URLSearchParams(window.location.search).get('caseId');
				if (caseId) {
					this.navigateToTab('case-details', caseId);
				}
			}
		},

		async applyFilters(updatedFilters) {
			this.filters = { ...updatedFilters };
			await this.getCases();
		},

		async getCases(page = 1) {
			this.loading = true;

			const params = { ...this.filters, page, archived: false };

			try {
				const response = await CasesService.getCases(Spark.state.currentTeam.id, params);
				this.cases = response.data;
				this.pagination = {
					current_page: response.current_page,
					last_page: response.last_page,
					total: response.total,
				};
			} catch (error) {
				console.error('Error fetching cases:', error.message);
			} finally {
				this.loading = false;
			}
		},

		async pinCase(caseToPin, pin) {
			const payload = { is_pinned: pin };

			try {
				await CasesService.updateCase(Spark.state.currentTeam.id, caseToPin.id, payload);
				await this.getCases();
			} catch (error) {
				console.error('Error pinning/unpinning the case:', error.message);
			}
		},

		async archiveCase(caseToArchive) {
			swal(
				{
					title: `Are you sure you want to resolve the "${caseToArchive.title}" case?`,
					text: 'The action will apply immediately.',
					type: 'warning',
					showCancelButton: true,
					confirmButtonClass: 'btn btn-danger',
					cancelButtonClass: 'btn btn-primary',
					confirmButtonText: 'Yes, Resolve it!',
				},
				async (result) => {
					if (result) {
						const payload = { archive: true };

						try {
							const response = await CasesService.updateCase(
								Spark.state.currentTeam.id,
								caseToArchive.id,
								payload,
							);
							if (response) {
								swal('Done!', 'The case has been successfully archived', 'success');
								await this.getCases(); // Refresh the cases list
							} else {
								swal(
									'Whoops!',
									'Something went wrong while archiving the case.',
									'error',
								);
							}
						} catch (error) {
							swal('Whoops!', 'Something went wrong.', 'error');
							console.error('Error archiving the case:', error.message);
						}
					}
				},
			);
		},

		navigateToTab(tab, data) {
			this.$eventHub.$emit('activateTab', tab, data);
			$(this.$el).closest('div[role="tabcard"]').removeClass('active');
			$(`#${tab}`).addClass('active');
		},
	},
};
</script>

